import { render, staticRenderFns } from "./DiagnosticTouch.vue?vue&type=template&id=662284ad&scoped=true"
import script from "./DiagnosticTouch.vue?vue&type=script&lang=ts"
export * from "./DiagnosticTouch.vue?vue&type=script&lang=ts"
import style0 from "./DiagnosticTouch.vue?vue&type=style&index=0&id=662284ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662284ad",
  null
  
)

export default component.exports